import {Link} from 'react-router-dom';
const LoginLink = (props)=>{
    return (
        <div>
            Already have an account? <Link to="/login">Login</Link> now.
        </div>
    );
}
export default LoginLink;